import SYSTEM_STATUS from "constants/systemStatus";

import { COUNTRIES_WITH_CODE } from "pages/Systems/SystemForm.constant";

import { isStringType, systemStatusText, getTrueOrFalse } from "./utils";

export const caseInsensitiveComparator = (valueA, valueB) => {
  const lowerCaseA = isStringType(valueA) ? valueA.toLocaleLowerCase() : "";
  const lowerCaseB = isStringType(valueB) ? valueB.toLocaleLowerCase() : "";

  if (lowerCaseA === lowerCaseB) {
    return 0;
  } else if (lowerCaseA < lowerCaseB) {
    return -1;
  } else {
    return 1;
  }
};

export const numberComparatorForFormattedValues = (numA, numB, nodeA, nodeB) => {
  if (isNaN(numA) && isNaN(numB)) {
    return 0;
  }
  if (isNaN(numA) || nodeA?.data?.connectionStatus !== SYSTEM_STATUS.STATUS_ONLINE) {
    return 1;
  }
  if (isNaN(numB) || nodeB?.data?.connectionStatus !== SYSTEM_STATUS.STATUS_ONLINE) {
    return -1;
  }

  return numA - numB;
};

export const basicNumberComparator = (numA, numB) => numA - numB;

export const systemStatusComparator = (numA, numB, nodeA, nodeB) => {
  const statusA = systemStatusText(nodeA);
  const statusB = systemStatusText(nodeB);
  return statusA.localeCompare(statusB);
};

function splitLastOccurrence(str, substring) {
  const lastIndex = str.lastIndexOf(substring);
  const before = str.slice(0, lastIndex);
  return before;
}

export const dateComparator = (date1, date2) => {
  const date1Updated = splitLastOccurrence(date1, " ");
  const date2Updated = splitLastOccurrence(date2, " ");
  const d1 = new Date(date1Updated);
  const d2 = new Date(date2Updated);
  if (d1 > d2) {
    return -1;
  } else if (d1 < d2) {
    return 1;
  } else {
    return 0;
  }
};

export const statusComparator = (statusA, statusB) => {
  const newStatusA = getTrueOrFalse(statusA);
  const newStatusB = getTrueOrFalse(statusB);
  if (newStatusA === newStatusB) {
    return 0;
  } else if (newStatusA && !newStatusB) {
    return 1;
  }
  return -1;
};

export const locationComparator = (locationA, locationB) => {
  const countryA = COUNTRIES_WITH_CODE[locationA];
  const countryB = COUNTRIES_WITH_CODE[locationB];
  return caseInsensitiveComparator(countryA, countryB);
};
